module.exports = __webpack_public_path__ + "static/media/compriamo.c206471e.jpg";